import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";



export const STORE_PRICE_TOAST_CONTAINER_ID = "store-price-toast-container";



export const toastifyMessage = (notificationData) => {

  const { status, message, containerId } = notificationData;



  const toastOptions = {

    position: containerId ? "top-center" : "top-right",

    containerId: containerId || undefined,

    className: containerId ? "price-details-toast" : undefined,

    autoClose: 5000,

    hideProgressBar: false,

    closeOnClick: true,

    pauseOnHover: true,

    draggable: false,

    progress: undefined,

  };



  if (status === 200 || status === "success") {

    toast.success(message, toastOptions);

  } else {

    toast.error(message, toastOptions);

  }

};



export const storePriceToastMessage = (notificationData) =>

  toastifyMessage({

    ...notificationData,

    containerId: STORE_PRICE_TOAST_CONTAINER_ID,

  });

